export const retrieveToken = () => {
  return localStorage.getItem('token');
};

export const saveToken = (token) => {
  localStorage.setItem('token', token);
};

export const retrieveRefreshToken = () => {
  return localStorage.getItem('refreshToken');
};

export const saveRefreshToken = (refreshToken) => {
  if (refreshToken) {
    localStorage.setItem('refreshToken', refreshToken);
  }
};

export const clearToken = () => {
  localStorage.clear();
};

export const clearSessionStorage = () => {
  sessionStorage.clear();
};

export const setConsulenteId = (consulenteId) => {
  localStorage.setItem('consulenteId', consulenteId);
};

export const getConsulenteId = () => {
  return localStorage.getItem('consulenteId');
};

export const isLoggedUserAConsulente = () => {
  return (
    localStorage.getItem('consulenteId') !== null &&
    localStorage.getItem('consulenteId') !== 'null'
  );
};

export const setSuperconsulente = (flag) => {
  localStorage.setItem('superconsulente', flag);
};

export const isSuperconsulente = () => {
  return localStorage.getItem('superconsulente') === 'true';
};

export const setGruppoId = (gruppoId) => {
  localStorage.setItem('gruppoId', gruppoId);
};

export const getGruppoId = () => {
  return localStorage.getItem('gruppoId');
};

export const setBrandId = (id) => {
  localStorage.setItem('brand', id);
};

export const getBrandId = () => {
  return localStorage.getItem('brand');
};
export const setChapterIndex = (chapterIndex) => {
  localStorage.setItem('chapterIndex', chapterIndex);
};
export const getChapterIndex = () => {
  return localStorage.getItem('chapterIndex') !== null
    ? localStorage.getItem('chapterIndex')
    : '0';
};
export const setParagraphIndex = (paragraphIndex) => {
  localStorage.setItem('paragraphIndex', paragraphIndex);
};
export const getParagraphIndex = () => {
  return localStorage.getItem('paragraphIndex') !== null
    ? localStorage.getItem('paragraphIndex')
    : '0';
};

export const isAdminUser = () => {
  const consulenteId = localStorage.getItem('consulenteId');
  return consulenteId === null || consulenteId === 'null';
};

export const isConsulenteUser = () => {
  const consulenteId = localStorage.getItem('consulenteId');
  const hasConsulenteId = consulenteId !== null && consulenteId !== 'null';
  return hasConsulenteId && !isSuperconsulente();
};

export const isSuperConsulenteUser = () => {
  const consulenteId = localStorage.getItem('consulenteId');
  const hasConsulenteId = consulenteId !== null && consulenteId !== 'null';
  return hasConsulenteId && isSuperconsulente();
};
